'use client';

import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from '@nextui-org/react';

const TableDummy: React.FC<{ name: string; details: string }> = ({ name, details }) => {
  return (
    <div>
      <Table aria-label="X" className="mt-12">
        <TableHeader>
          <TableColumn>{name}</TableColumn>
          <TableColumn>Property 1</TableColumn>
          <TableColumn>Property 2</TableColumn>
          <TableColumn>Actions</TableColumn>
        </TableHeader>
        <TableBody>
          <TableRow key="1">
            <TableCell>Row 1</TableCell>
            <TableCell>...</TableCell>
            <TableCell>...</TableCell>
            <TableCell>
              <Link href={details}>View details</Link>
            </TableCell>
          </TableRow>
          <TableRow key="2">
            <TableCell>Row 2</TableCell>
            <TableCell>...</TableCell>
            <TableCell>...</TableCell>
            <TableCell>...</TableCell>
          </TableRow>
          <TableRow key="3">
            <TableCell>...</TableCell>
            <TableCell>...</TableCell>
            <TableCell>...</TableCell>
            <TableCell>...</TableCell>
          </TableRow>
          <TableRow key="4">
            <TableCell>Row N</TableCell>
            <TableCell>...</TableCell>
            <TableCell>...</TableCell>
            <TableCell>...</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

export default TableDummy;
